import { render, staticRenderFns } from "./index.vue?vue&type=template&id=004475d0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004475d0')) {
      api.createRecord('004475d0', component.options)
    } else {
      api.reload('004475d0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=004475d0", function () {
      api.rerender('004475d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userSystem/userInfo/components/noticePage/index.vue"
export default component.exports